import { PrimaryButton } from '../../components/button/PrimaryButton';
import { ArrowUpRightIcon } from '../../components/icons/ArrowUpRightIcon';
import { useFetchOnboardingLink } from '../../hooks/useFetchOnboardingLink';
import { t } from '../../services/translation/translation';

type Props = {
  label?: string;
};

export const GoToStripeOnboardingButton = ({ label }: Props) => {
  const { mutate: fetchOnboardingLink, isLoading } = useFetchOnboardingLink();

  const handleFetchOnboarding = () => {
    fetchOnboardingLink(undefined, {
      onSuccess: data => {
        window.open(data.link);
      },
    });
  };

  return (
    <PrimaryButton onClick={handleFetchOnboarding} isLoading={isLoading}>
      <div className="flex items-center gap-2">
        {label ?? t('common.complete')}
        <ArrowUpRightIcon className="w-4 h-4" />
      </div>
    </PrimaryButton>
  );
};
